import { render, staticRenderFns } from "./MessageNotification.vue?vue&type=template&id=1a0a5cc3&scoped=true"
import script from "./MessageNotification.vue?vue&type=script&lang=js"
export * from "./MessageNotification.vue?vue&type=script&lang=js"
import style0 from "./MessageNotification.vue?vue&type=style&index=0&id=1a0a5cc3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a5cc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0a5cc3')) {
      api.createRecord('1a0a5cc3', component.options)
    } else {
      api.reload('1a0a5cc3', component.options)
    }
    module.hot.accept("./MessageNotification.vue?vue&type=template&id=1a0a5cc3&scoped=true", function () {
      api.rerender('1a0a5cc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chat/Message/MessageNotification.vue"
export default component.exports